import { c as _c } from "react/compiler-runtime";
import { Form, Shimmer } from '@onefootprint/ui';
import { useTranslation } from 'react-i18next';
import type { DocumentExtractionFormData } from './document-extraction-form';
type DocumentIdentifierSelectProps = {
  documentOptions: {
    label: string;
    value: string;
  }[] | undefined;
  canEdit: boolean;
};
const DocumentIdentifierSelect = t0 => {
  const $ = _c(23);
  const {
    documentOptions,
    canEdit
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "documentExtractionNode.configurationSection.document"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("playbook-builder", t1);
  if (!documentOptions) {
    let t2;
    if ($[1] !== t) {
      t2 = t(_temp);
      $[1] = t;
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    let t3;
    if ($[3] !== t2) {
      t3 = <span className="text-label-2 text-primary">{t2}</span>;
      $[3] = t2;
      $[4] = t3;
    } else {
      t3 = $[4];
    }
    let t4;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <Shimmer width="100%" height="40px" />;
      $[5] = t4;
    } else {
      t4 = $[5];
    }
    let t5;
    if ($[6] !== t3) {
      t5 = <div className="flex flex-col gap-2">{t3}{t4}</div>;
      $[6] = t3;
      $[7] = t5;
    } else {
      t5 = $[7];
    }
    return t5;
  }
  const t2 = !canEdit || documentOptions.length === 0;
  let t3;
  if ($[8] !== t) {
    t3 = t(_temp2);
    $[8] = t;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== t) {
    t4 = t(_temp3);
    $[10] = t;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  let t5;
  if ($[12] !== t4) {
    t5 = {
      required: t4
    };
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== documentOptions.length || $[15] !== t) {
    t6 = documentOptions.length === 0 ? t(_temp4) : undefined;
    $[14] = documentOptions.length;
    $[15] = t;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== documentOptions || $[18] !== t2 || $[19] !== t3 || $[20] !== t5 || $[21] !== t6) {
    t7 = <Form.Select name="documentIdentifier" disabled={t2} label={t3} options={documentOptions} rules={t5} hint={t6} />;
    $[17] = documentOptions;
    $[18] = t2;
    $[19] = t3;
    $[20] = t5;
    $[21] = t6;
    $[22] = t7;
  } else {
    t7 = $[22];
  }
  return t7;
};
export default DocumentIdentifierSelect;
function _temp($) {
  return $.label;
}
function _temp2($_0) {
  return $_0.label;
}
function _temp3($_1) {
  return $_1.required;
}
function _temp4($_2) {
  return $_2.emptyHint;
}